// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/estoque/services/inventarioService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  InventarioResumo,
  InventarioDetalhe,
  CriarInventarioRequest,
  LancarContagemRequest,
  PaginadoResponse,
} from '../types';

const BASE = '/api/inventarios';

/** Filtros da lista (servidor). Período = dia LOCAL do inventário, yyyy-MM-dd. */
export interface FiltrosInventario {
  busca?: string;
  processado?: boolean;
  dtInicio?: string;
  dtFim?: string;
  ordenarPor?: 'data' | 'id';
  decrescente?: boolean;
}

export const inventarioService = {
  async getAll(pagina = 1, tamanhoPagina = 20, filtros: FiltrosInventario = {}): Promise<PaginadoResponse<InventarioResumo>> {
    const { data } = await apiClient.get<PaginadoResponse<InventarioResumo>>(BASE, {
      params: {
        pagina, tamanhoPagina,
        busca: filtros.busca?.trim() || undefined,
        processado: filtros.processado,
        dtInicio: filtros.dtInicio || undefined,
        dtFim: filtros.dtFim || undefined,
        ordenarPor: filtros.ordenarPor,
        decrescente: filtros.decrescente,
      },
    });
    return data;
  },

  async getById(id: number): Promise<InventarioDetalhe> {
    const { data } = await apiClient.get<InventarioDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(req: CriarInventarioRequest): Promise<InventarioResumo> {
    const { data } = await apiClient.post<InventarioResumo>(BASE, req);
    return data;
  },

  async lancarContagem(id: number, req: LancarContagemRequest): Promise<{ mensagem: string }> {
    const { data } = await apiClient.post<{ mensagem: string }>(`${BASE}/${id}/itens`, req);
    return data;
  },

  async processar(id: number): Promise<{ mensagem: string }> {
    const { data } = await apiClient.put<{ mensagem: string }>(`${BASE}/${id}/processar`);
    return data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
